/**
 * Verifica se um corretor é isento de ranqueamento e premiação no pódio.
 * O corretor "Loja" (com nome "Loja" ou variações / e-mail da imobiliária)
 * pode cadastrar e registrar vendas normalmente no sistema.
 * Suas vendas SÃO contabilizadas no acumulado e metas gerais do dashboard,
 * porém ele NÃO participa dos ranqueamentos (fica fora do Pódio/PalanqueTop5 e da Lista de Corretores).
 * 
 * @param {Object} corretor 
 * @returns {boolean}
 */
export const isCorretorSemPontuacao = (corretor) => {
  if (!corretor) return false;
  const nome = (corretor.nome || '').toLowerCase().trim();
  const email = (corretor.email || '').toLowerCase().trim();

  // O corretor "Loja" tem o nome "loja" ou correspondência de palavra "loja", ou e-mail institucional da loja
  if (
    nome === 'loja' || 
    nome.startsWith('loja ') ||
    nome.endsWith(' loja') ||
    /\bloja\b/i.test(nome) ||
    email === 'primeclassimobiliaria.com.br' ||
    email === 'loja@primeclassimobiliaria.com.br' ||
    email.startsWith('loja@')
  ) {
    return true;
  }

  return false;
};
